import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "./axiosInstance";

const VerifyEmail = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState("verifying");
    const [message, setMessage] = useState("");

    useEffect(() => {
        const token = searchParams.get("token");
        if (!token) {
            setStatus("error");
            setMessage("This verification link is invalid or has expired. Please request a new one from the sign-in page.");
            return;
        }

        api.get(`/auth/verify-email?token=${token}`)
            .then(() => {
                setStatus("success");
                setMessage("Your email has been verified. You can now sign in.");
            })
            .catch(() => {
                setStatus("error");
                setMessage("This verification link is invalid or has expired. Please request a new one from the sign-in page.");
            });
    }, [searchParams]);

    return (
        <div className="min-h-screen flex items-center justify-center bg-darkblue text-lightgray">
            <div className="w-full max-w-md bg-bluegray shadow-lg rounded-lg p-6 text-center">
                <h1 className="text-3xl font-bold text-orange mb-6">Email Verification</h1>

                {status === "verifying" && (
                    <p className="text-lightgray">Verifying your email...</p>
                )}

                {status === "success" && (
                    <>
                        <p className="text-green-400 mb-4">{message}</p>
                        <Link
                            to="/signin"
                            className="inline-block py-2 px-6 bg-orange text-white font-medium rounded hover:bg-deeporange"
                        >
                            Sign In
                        </Link>
                    </>
                )}

                {status === "error" && (
                    <p className="text-red-400">{message}</p>
                )}
            </div>
        </div>
    );
};

export default VerifyEmail;
